import React, { useContext } from "react";
import { Row } from "react-bootstrap";
import { MdCheckCircle, MdCancel } from "react-icons/md";

import { Task } from "../../helpers/Contexts";
import * as CONST from "../../helpers/Constants";

const TaskOutcomes = ({ task }) => {
  const { taskValues, setTaskValues } = useContext(Task);
  const response = CONST.RESPONSE_OUTCOMES;
  const outreach = CONST.OUTREACH_OUTCOMES;

  return (
    <>
      <Row className={"pad20 mb-t20"}>
        <label>{"TASK OUTCOMES "}</label>
        {task.pcp_15min_response_completed == null &&
        task.pcp_patient_30min_outreach_completed == null ? (
          <>
            <small id="from">Select All That Apply</small>
            <br />
            <form>
              <b>Did PCP respond in 15 minutes or less ?</b> <br />
              <select
                name="pcp_15min_response_completed"
                value={taskValues.outcomes.pcp_15min_response_completed}
                onChange={(e) => {
                  setTaskValues({
                    ...taskValues,
                    outcomes: {
                      ...taskValues.outcomes,
                      pcp_15min_response_completed: e.target.value,
                    },
                  });
                }}
              >
                <option value=""> {"Select an option"}</option>
                <option value={true}>{"Yes. " + response.completed}</option>
                <option value={false}>{"No. " + response.notCompleted}</option>
              </select>
              <br />
              <br />
              <b> {"Did PCP complete patient outreach requirement in 30 minutes or less ? "}</b>
              <br />
              <select
                name="pcp_patient_30min_outreach_completed"
                value={taskValues.outcomes.pcp_patient_30min_outreach_completed}
                onChange={(e) => {
                  setTaskValues({
                    ...taskValues,
                    outcomes: {
                      ...taskValues.outcomes,
                      pcp_patient_30min_outreach_completed: e.target.value,
                    },
                  });
                }}
              >
                <option value="">{"Select an option"}</option>
                <option value={true}>{"Yes. " + outreach.completed}</option>
                <option value={false}>{"No. " + outreach.notCompleted}</option>
              </select>
            </form>
          </>
        ) : (
          <>
            {task.pcp_15min_response_completed == true ? (
              <p>
                <MdCheckCircle className="outcome-icon " />
                {response.completed}
              </p>
            ) : (
              <p>
                <MdCancel className="outcome-icon " />
                {response.notCompleted}
              </p>
            )}

            {task.pcp_patient_30min_outreach_completed == true ? (
              <p>
                <MdCheckCircle className="outcome-icon " />
                {outreach.completed}
              </p>
            ) : (
              <p>
                <MdCancel className="outcome-icon" />
                {outreach.notCompleted}
              </p>
            )}
          </>
        )}{" "}
      </Row>
    </>
  );
};
export default TaskOutcomes;
